export default __webpack_public_path__ + "static/mazda 6-b232627e04fd6c4b2834bd911bf8255c.png";